import * as next from '../../../types/next'
import type { BlockUiSchema } from '../../../utils'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.AppBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.CUSTOM_BLOCK_CONTROL) {
    throw new Error('Expected a valid CustomeBlock control')
  }

  return {
    type: next.BLOCK_TYPE.APP,
    settings: {
      ...upCommonSettings(uischema),
      ...upCustomBlockSettingsToAppBlockSettings(uischema)
    }
  }
}

function upCustomBlockSettingsToAppBlockSettings(uischema: BlockUiSchema) {
  return {
    type: next.AppType.CUSTOM_BLOCK,
    bundleURL: uischema.options?.bundleURL,
    tag: uischema.options?.tagName,
    args: uischema.options?.args
  }
}
